export enum CategoryType{
  Gowns,

  Shirts,

  Bags,

  Shoes,

  Trousers,

  Skirts,

  LongGown,

  DinnerGown,

  PatternedGown,

  PlainColorGown,

  ShortGown,

  PatternedSGown,

  PlainColorSGown,

  ChurchGown,

  OfficeGown,

  TraditionalWearGown,

  AnkaraGown,

  LaceGown,

  GuineaGown,

  LongSleevedShirt,

  CheckedShirts,

  PlainShirts,

  ChiffonShirts,

  PeplumShirts,

  ShortSleevedShirts,

  CheckedShortShirts,

  PlainShortShirts,

  ChiffonShortShirts,

  PeplumShortShirts,

  TraditionalWearShirts,

  AnkaraTop,

  GuineaTop,

  Pants,

  Shorts,

  OfficeTrousers,

  Jeans,

  Jergens,

  ThreeQJeans,

  BumpShorts,

  TraditionalWearTrouser,

  AnkaraTrouser,

  GuineaTrouser,

  Flats,

  Suade,

  ShinyShoe,

  Leather,

  Sandals,

  Heels,

  Stilettos,

  BlockHeels,

  SandalHeels,

  Sneakers,

  PencilSkirts,

  CheckedPencilSkirts,

  PlainPencilSkirts,

  FloweredPencilSkirts,

  ALineSkirts,

  PlainA_Line,

  FloweryA_Line,

  PlainCheckedA_Line,

  BandageSkirts,

  JeanSkirts,

  CarribeanSkirts,

  TraditionalWearSkirts,

  AnkaraSkirt,

  GuineaSkirt

}
